import React, { useEffect, useState } from 'react'
import { getDateNow , convertDateToString } from '../utils'

export const ContextDelay = React.createContext<any>({})


export default function ContextDelayModels(props: any) {
    const [jsonParmsDelay, setJsonParmsDelay] = useState<any>({ 'from': getDateNow(), 'to': getDateNow() , 'page':1 , 'user':[] })
    const [activeFilterDelay, setActiveFilterDelay] = useState<any>({
        'activePeriod': -1 ,
        'qr_code_id':-1 ,
        'status':-1 ,
        'user':[],
        'startCalender':convertDateToString(getDateNow()) ,
        'endCalender':convertDateToString(getDateNow()) ,
    })




    return (
        <ContextDelay.Provider value={{
            activeFilterDelay,
            setActiveFilterDelay ,
            jsonParmsDelay ,
            setJsonParmsDelay
        }}>
            {props.children}
        </ContextDelay.Provider>
    )
}